<template>
    <div class="DiscipLine">
        <iframe class="iframe" id="content" src="https://finebi.randforest.cn/webroot/decision/link/lgGW"></iframe>
    </div>
</template>

<script>
export default {

}
</script>

<style>
    .iframe{
        width: 100%;
        height: calc(100vh - 60px);
        border: none;
    }
</style>